import React, { useState } from "react";
import AuthLayout from "../AuthLayout";
import InputField from "../../shared/InputField";
import { requestResetPassword } from "../../../api/authApis";
import { showSuccessToast, showErrorToast } from "../../../utils/Toasts";
import Button from "../../shared/Button";
const App = () => {
  const [form, setForm] = useState({ email: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const errs = {};
    if (!form.email) {
      errs.email = "Eamil is required";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      errs.email = "Invalid email format";
    }
    return errs;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    const validationsErrors = validate();
    if (Object.keys(validationsErrors).length === 0) {
      setLoading(true);
      try {
        const response = await requestResetPassword(form);
        if (response.data.success) {
          showSuccessToast(response.data.message);
          window.location.href = "/sign-in";
        } else {
          response.data.errors.forEach((error) => {
            showErrorToast(error);
          });
        }
      } catch (error) {
        showErrorToast("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    } else {
      setErrors(validationsErrors);
    }
  };
  return (
    <AuthLayout>
      <div className="w-[360px] sm:w-[500px] max-w-full min-h-[420px] bg-white rounded-lg border border-[#ebebeb] py-[45px] px-6 sm:px-[55px] mt-[120px] mx-auto max-sm:mb-[100px]">
        <h1 className="text-2xl text-center font-semibold mt-5 mb-8">Forgot your password?</h1>
        <div className="mb-10">
          <div class="flex items-center">
            <svg class="h-5 w-5 text-red-800" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path
                fill-rule="evenodd"
                d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd"
              />
            </svg>
            <h3 class="ml-2 text-sm font-medium text-red-800">Heads up!!</h3>
          </div>
          <div class="mt-2 text-sm text-red-700">
            <p>
              This email will <strong>most likely</strong> end up in your spam. You need to remove it from spam to access the reset password link.{" "}
            </p>
          </div>
        </div>
        <form onSubmit={handleSubmit} noValidate className="mb-6">
          <div className="mb-6">
            <InputField
              label="Email"
              labelClasses="!arial-font font-normal !text-[#636363]"
              name="email"
              type="email"
              value={form.email}
              error={errors.email}
              onChange={handleChange}
              extraClasses="!bg-[#fbf7f55e] !border-gray-200 !rounded-md"
            />
          </div>
          <Button disabled={loading} type="submit" className="w-full !rounded-[5px] !py-3 !px-0 !text-base">
            {loading ? "Sending..." : "Send me reset password instructions"}
          </Button>
        </form>
        <div className="flex items-center justify-center gap-2 text-sm mb-5">
          <p className=" text-[#000]">Already have an account? </p>
          <a href="/sign-in" className="underline text-[#550df4]">
            Login here
          </a>
        </div>
      </div>
    </AuthLayout>
  );
};
export default App;
